import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { AppProvider } from './context/AppContext';
import store, { persistor } from './modules/store';
import GlobalStyle from './css/global-style';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
// import './firebase';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import './css/theme-css/core.css';
import './css/theme-css/node-waves.css';
import './css/theme-css/perfect-scrollbar.css';
import './css/theme-css/tabler-icons.css';
import './css/theme-css/theme-default.css';
import RouterLayout from './RouterLayout';
import NetworkInterceptor from './modules/utils/interceptor';
NetworkInterceptor.setupInterceptors(store);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <AppProvider>
        <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
                <BrowserRouter basename={'/'}>
                    <GlobalStyle />
                    <RouterLayout />
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </AppProvider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
